import { render } from "./StatedImplants.vue?vue&type=template&id=518a4659&scoped=true"
import script from "./StatedImplants.vue?vue&type=script&lang=js"
export * from "./StatedImplants.vue?vue&type=script&lang=js"

import "./StatedImplants.vue?vue&type=style&index=0&id=518a4659&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518a4659"]])

export default __exports__